import styled from "styled-components";
import {media} from "assets/css/media";

export const PartnersLinksWrapper = styled.div`
	padding: 24px 0;
`;

export const PartnersLinks = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	flex-wrap: wrap;
	max-width: 1100px;
	margin: 0 auto;
	gap: 16px 72px;

	a img {
		height: 50px;
	}

	@media (max-width: ${media.tablet}) {
		max-width: 600px;
	}

	@media (max-width: ${media.mobile}) {
		max-width: 400px;
	}
`;

export const Title = styled.h6`
	color: #fff;
	font-size: 12px;
	font-weight: 500;
	text-align: center;
	line-height: 18px;
	margin-bottom: 16px;
`;

export const PartnerLink = styled.a``;
